import api from '../../lib/api';
import type { SgDashboardData } from './types';

export interface FetchSgDashboardParams {
  from?: string;
  to?: string;
}

export const fetchSgDashboard = async (
  params: FetchSgDashboardParams = {},
): Promise<SgDashboardData> => {
  const { data } = await api.get<{ data: SgDashboardData }>('sg-dashboard', { params });
  return data.data;
};
